import Swal from "sweetalert2";
import HelperMixin from '../../Shared/HelperMixin.vue';
import PaginationHelper from '../../Shared/PaginationHelper.vue';
export default {
    name: 'Courses',
    mixins: [HelperMixin],
    components: {
        PaginationHelper
    },

    async created() {
        this.loginDetails = await this.CheckLoginStatus();

        if (!this.requireUserType([1])) return;
        await this.GetAllDistributors();

        this.GetInfo();
    },

    computed: {
        totalPages() {
            return Math.ceil(this.pages / this.pageSize);
        }
    },

    data() {
        return {
            pageNo: 1,
            pageSize: 10,
            pages: 0,
            state: 0,
            Search: '',
            DistributorsId: '',

            ScreenTitle: '  الباقات  ',
            ScreenTitleSingle: '  باقة   ',
            ScreenTitleSingleAl: ' الباقة  ',

            Info: [],
            Statistics: [],

            AddDialog: false,

            SelectedItem: '',
            activeTab: 'info',

            ruleForm: {
                Id: '',
                DistributorsId: '',
                Name: '',
                CardCount: '',
                CardAmount: '',
            },
            rules: {
                DistributorsId: this.$helper.Required(),
                Name: this.$helper.Required(),
                CardCount: this.$helper.Required(),
                CardAmount: this.$helper.Required(),
            },
        };
    },

    methods: {

        GetInfo(pageNo) {
            this.pageNo = pageNo;
            if (this.pageNo === undefined) {
                this.pageNo = 1;
            }

            if (!this.Search)
                this.$blockUI.Start();
            this.$http.GetVoucherCards(this.pageNo, this.pageSize, this.Search, this.DistributorsId)
                .then(response => {
                    if (!this.Search)
                        this.$blockUI.Stop();

                    this.Info = response.data.info;
                    this.pages = response.data.count;
                    this.Statistics = response.data.statistics;
                })
                .catch(() => {
                    if (!this.Search)
                        this.$blockUI.Stop();
                    this.pages = 0;
                });
        },

        submitForm(formName) {
            this.$refs[formName].validate((valid) => {
                if (valid) {
                    this.ruleForm.Id = Number(0);
                    this.ruleForm.CardCount = Number(this.ruleForm.CardCount);
                    this.ruleForm.CardAmount = Number(this.ruleForm.CardAmount);

                    this.$blockUI.Start();
                    this.$http.AddVoucherCards(this.ruleForm)
                        .then(response => {
                            this.$blockUI.Stop();
                            this.GetInfo();
                            this.ClearForm(this.ruleForm);
                            this.$helper.DestroyElemntById('Close');
                            this.$helper.ShowMessage('success', 'عملية ناجحة', response.data);
                        })
                        .catch((err) => {
                            this.$blockUI.Stop();
                            if (err.response && err.response.data) {
                                this.$helper.ShowMessage('error', 'خطأ بعملية الإضافة', err.response.data);
                            } else {
                                this.$helper.ShowMessage('error', 'خطأ بعملية الإضافة', 'حدت خطاء غير متوقع');
                            }
                        });


                } else {
                    this.$helper.showSwal('warning');
                    return false;
                }
            });
        },

        ViewInfo(item) {
            this.SelectedItem = item;
            this.activeTab = 'info';
            this.state = 1;
        },


        Sale(Id) {
            Swal.fire({
                title: 'تأكيد العملية ',
                text: ' هـل انت متأكد من  تأكيد عملية بيع الباقة    ؟',
                icon: 'question',
                showCancelButton: true,
                customClass: {
                    confirmButton: 'btn btn-primary',
                    cancelButton: 'btn btn-light ms-2'
                },
                buttonsStyling: false,
                confirmButtonText: `تأكيد العملية`,
                cancelButtonText: 'إلغاء',
            }).then((result) => {
                if (result.isConfirmed) {
                    this.$blockUI.Start();
                    this.$http.SaleVoucherCards(Id)
                        .then((response) => {
                            this.$blockUI.Stop();
                            this.$helper.ShowMessage('success', 'عملية ناجحة', 'تمت عملية بيع الكروت بنجاح');
                            this.GetInfo();
                            const url = window.URL.createObjectURL(new Blob([response.data]));
                            const fileName = response.headers['content-disposition'].split(';')[1].trim().split('=')[1];
                            const link = document.createElement('a');
                            link.href = url;
                            link.setAttribute('download', fileName);
                            document.body.appendChild(link);
                            link.click();
                            document.body.removeChild(link);
                        })
                        .catch((err) => {
                            this.$blockUI.Stop();
                            if (err.response && err.response.data) {
                                this.$helper.ShowMessage('error', 'خطأ بعملية التعديل', err.response.data);
                            } else {
                                this.$helper.ShowMessage('error', 'خطأ بعملية التعديل', 'حدت خطاء غير متوقع');
                            }
                        });
                    return;
                }
            });
        },

        ForzePackage(Id) {
            Swal.fire({
                title: 'تأكيد العملية ',
                text: ' هـل انت متأكد من  عملية تجميد الباقة  ؟',
                icon: 'question',
                showCancelButton: true,
                customClass: {
                    confirmButton: 'btn btn-primary',
                    cancelButton: 'btn btn-light ms-2'
                },
                buttonsStyling: false,
                confirmButtonText: `تأكيد العملية`,
                cancelButtonText: 'إلغاء',
            }).then((result) => {
                if (result.isConfirmed) {
                    this.$blockUI.Start();
                    this.$http.ForzePackage(Id)
                        .then((response) => {
                            this.$blockUI.Stop();
                            this.$helper.ShowMessage('success', 'عملية ناجحة', response.data);
                            this.GetInfo();
                        })
                        .catch((err) => {
                            this.$blockUI.Stop();
                            if (err.response && err.response.data) {
                                this.$helper.ShowMessage('error', 'خطأ بعملية التعديل', err.response.data);
                            } else {
                                this.$helper.ShowMessage('error', 'خطأ بعملية التعديل', 'حدت خطاء غير متوقع');
                            }
                        });
                    return;
                }
            });
        },

        UnfreezePackage(Id) {
            Swal.fire({
                title: 'تأكيد العملية ',
                text: ' هـل انت متأكد من عملية إلغاء تجميد الباقة ؟',
                icon: 'question',
                showCancelButton: true,
                customClass: {
                    confirmButton: 'btn btn-primary',
                    cancelButton: 'btn btn-light ms-2'
                },
                buttonsStyling: false,
                confirmButtonText: `تأكيد العملية`,
                cancelButtonText: 'إلغاء',
            }).then((result) => {
                if (result.isConfirmed) {
                    this.$blockUI.Start();
                    this.$http.UnfreezePackage(Id)
                        .then((response) => {
                            this.$blockUI.Stop();
                            this.$helper.ShowMessage('success', 'عملية ناجحة', response.data);
                            this.GetInfo();
                        })
                        .catch((err) => {
                            this.$blockUI.Stop();
                            if (err.response && err.response.data) {
                                this.$helper.ShowMessage('error', 'خطأ بعملية التعديل', err.response.data);
                            } else {
                                this.$helper.ShowMessage('error', 'خطأ بعملية التعديل', 'حدت خطاء غير متوقع');
                            }
                        });
                    return;
                }
            });
        },

        Delete(Id) {
            Swal.fire({
                title: 'تأكيد العملية ',
                text: ' هـل انت متأكد من عملية الحذف  ؟',
                icon: 'question',
                showCancelButton: true,
                customClass: {
                    confirmButton: 'btn btn-primary',
                    cancelButton: 'btn btn-light ms-2'
                },
                buttonsStyling: false,
                confirmButtonText: `تأكيد العملية`,
                cancelButtonText: 'إلغاء',
            }).then((result) => {
                if (result.isConfirmed) {
                    this.$blockUI.Start();
                    this.$http.DeletePackage(Id)
                        .then((response) => {
                            this.$blockUI.Stop();
                            this.$helper.ShowMessage('success', 'عملية ناجحة', response.data);
                            this.GetInfo();
                        })
                        .catch((err) => {
                            this.$blockUI.Stop();
                            if (err.response && err.response.data) {
                                this.$helper.ShowMessage('error', 'خطأ بعملية الحذف', err.response.data);
                            } else {
                                this.$helper.ShowMessage('error', 'خطأ بعملية الحذف', 'حدت خطاء غير متوقع');
                            }
                        });
                    return;
                }
            });
        },






        Refresh() {
            this.DistributorsId = '';
            this.Search = '';
            this.GetInfo();
        },

        // Human-readable label for a package status code. Shared by the CSV
        // export and the print view so they read the same as the table badges.
        statusText(status) {
            if (status == 1) return 'في انتظار تأكيد عملية البيع';
            if (status == 2) return 'في انتظار فتح الباقة من الموزع';
            if (status == 3) return 'باقة مفعلة';
            if (status == 4) return 'تم تجميد الباقة';
            return '—';
        },

        // Colour the expiry badge by urgency instead of always-red:
        // expired = danger, within 30 days = warning, otherwise success.
        expiryBadgeClass(date) {
            if (!date) return 'bg-secondary-subtle text-secondary';
            const days = Math.ceil((new Date(date).getTime() - Date.now()) / 86400000);
            if (days < 0) return 'bg-danger-subtle text-danger';
            if (days <= 30) return 'bg-warning-subtle text-warning';
            return 'bg-success-subtle text-success';
        },

        // Short non-blocking confirmation toast in the corner.
        toast(icon, title) {
            Swal.fire({
                toast: true, position: 'top-end', icon, title,
                showConfirmButton: false, timer: 1800, timerProgressBar: true,
            });
        },

        // Export CSV — handled by the BACKEND. The browser downloads the file directly
        // from the authenticated GET endpoint (cookie sent same-origin), which is far more
        // reliable across browsers than building a Blob in JS. The server returns ALL the
        // current filtered rows (not just the visible page) with a UTF-8 BOM.
        exportToCsv() {
            const url = '/api/admin/VoucherCards/ExportCsv'
                + '?Search=' + encodeURIComponent(this.Search || '')
                + '&DistributorsId=' + encodeURIComponent(this.DistributorsId || '');
            const a = document.createElement('a');
            a.href = url;
            a.setAttribute('download', `voucher-cards-${this.GetToday()}.csv`);
            document.body.appendChild(a);
            a.click();
            document.body.removeChild(a);
            this.toast('success', 'جاري تنزيل الملف');
        },

        // Download a package's voucher cards as a READABLE (unencrypted) CSV. The backend
        // decrypts the voucher numbers and returns الرقم التسلسلي / رقم القسيمة / القيمة.
        DownloadCards(Id) {
            const url = '/api/admin/VoucherCards/' + Id + '/Cards/Export';
            const a = document.createElement('a');
            a.href = url;
            a.setAttribute('download', '');
            document.body.appendChild(a);
            a.click();
            document.body.removeChild(a);
            this.toast('success', 'جاري تنزيل الكروت');
        },

        // Open the browser's print dialog with a printer-friendly version of
        // the table only (avoids printing the sidebar / header chrome).
        printTable() {
            if (!this.Info || this.Info.length === 0) {
                this.toast('warning', 'لا توجد بيانات للطباعة');
                return;
            }
            const esc = (v) => String(v ?? '—')
                .replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;');
            const rows = this.Info.map((item, index) => {
                const i = (this.pageNo - 1) * this.pageSize + index + 1;
                return `<tr>
                    <td>${i}</td>
                    <td>${esc(item.name)}</td>
                    <td>${esc(item.user)}</td>
                    <td>${esc(this.statusText(item.status))}</td>
                    <td>${esc(item.serialNumber)}</td>
                    <td>${esc(item.cardAmount)}</td>
                    <td>${esc(item.cardCount)}</td>
                    <td>${esc(item.salesAvg ?? 0)}%</td>
                    <td>${esc(item.createdOn ? this.moment(item.createdOn) : '—')}</td>
                </tr>`;
            }).join('');
            const html = `<!doctype html><html dir="rtl" lang="ar"><head><meta charset="utf-8">
                <title>قائمة الباقات — رفيق</title>
                <style>
                  body { font-family: 'Tajawal', 'Cairo', Arial, sans-serif; padding: 24px; color:#111; }
                  h1 { font-size: 18px; margin: 0 0 4px; }
                  .meta { font-size: 12px; color: #666; margin-bottom: 16px; }
                  table { width: 100%; border-collapse: collapse; }
                  th, td { border: 1px solid #ccc; padding: 8px 10px; text-align: right; font-size: 12px; }
                  thead { background: #f3f4f6; }
                  tbody tr:nth-child(even) { background: #fafafa; }
                </style></head><body>
                <h1>قائمة الباقات — رفيق</h1>
                <div class="meta">تاريخ الطباعة: ${new Date().toLocaleString('en-US')}</div>
                <table><thead><tr>
                  <th>#</th><th>اسم الباقة</th><th>الموزع</th><th>الحالة</th><th>الرقم التسلسلي</th>
                  <th>سعر الكرت</th><th>عدد الكروت</th><th>نسبة البيع</th><th>تاريخ الإنشاء</th>
                </tr></thead><tbody>${rows}</tbody></table>
            </body></html>`;
            const w = window.open('', '_blank', 'width=1000,height=720');
            if (!w) {
                this.toast('error', 'الرجاء السماح بالنوافذ المنبثقة لطباعة الصفحة');
                return;
            }
            w.document.open();
            w.document.write(html);
            w.document.close();
            w.focus();
            setTimeout(() => { w.print(); }, 250);
        },

        Back() {
            this.state = 0;
            this.GetInfo(this.pageNo);
            this.SelectedItem = '';
        }


    }
}
